import { useAppDispatch, useAppSelector } from './state'
import {
  getProducts as getProductsAPI,
  getProduct as getProductApi,
  getAdviceProducts as getAdviceProductsAPI
} from '../api/products'
import {
  setAdviceProducts,
  setIsLoading,
  setProduct,
  setProducts
} from '../state/slices/products_slice'
import { getResourceAuthorization } from '../state/selectors/resource_authorization'
import { IResourceAuthorization } from '../models/resource_authorization'

export const useProducts = () => {
  const dispatch = useAppDispatch()
  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)

  const getProducts = async () => {
    dispatch(setIsLoading(true))
    try {
      const result = await getProductsAPI()

      if (result.data) {
        dispatch(setProducts(result.data.products))
      }

      return true
    } catch (error) {
      return false
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  const getProduct = async (id: string) => {
    dispatch(setIsLoading(true))
    try {
      const result = await getProductApi(id)

      dispatch(setProduct(result.data.product))

      return true
    } catch (error) {
      return false
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  const getAdviceProducts = async (resourceAuthorization?: IResourceAuthorization) => {
    dispatch(setIsLoading(true))
    try {
      let relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber
      let agentNumber = currentResourceAuthorization?.relationInfo?.agentNumber

      if (resourceAuthorization) {
        relationNumber = resourceAuthorization?.relationInfo?.relationNumber
        agentNumber = resourceAuthorization?.relationInfo?.agentNumber
      }

      if (!relationNumber || !agentNumber) {
        return
      }

      const result = await getAdviceProductsAPI(agentNumber, relationNumber)

      if (result.data) {
        dispatch(setAdviceProducts(result.data))
      }

      return true
    } catch (error) {
      return false
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  return {
    getProducts,
    getProduct,
    getAdviceProducts
  }
}

export default useProducts
